module.exports = __webpack_public_path__ + "static/media/left-arrow.a5b93086.svg";